export default {
    data() {
        return {
            gates2dData: []
        }
    },
    created() {
        this.gates2dData = this.getGates2dData()
    },
    methods: {
        getGates2dData() {
            return [
                {
                    name: "Violet",
                    description: "Violet was apparently a gate for quirky, non-conformists! We’re still discovering new bits of history about Greenham, including more information on Violet gate. If you have any stories about Violet, please contact us! Please explore this gate and listen to some of the audio clips to hear memories from the Greenham Women who were there.",
                    audio: {
                        0: {
                            title: "Emerald Gate",
                            artist: "Christina Li inspired by Susan Kleckner",
                            tag: "Emerald Watch",
                            path: "/audio/contributed/violet/EmeraldGate_SusanKleckner.mp3",
                            cover: "/images/contributed/violet/green_AWomanLivedHere_SusanKleckner.wav.jpg",
                            covercredit: "Susan Kleckner"
                        },
                        1: {
                            title: "Interview Clip",
                            artist: "Penny Gulliver",
                            tag: "Emerald Watch",
                            path: "/audio/contributed/violet/Interview_PennyGulliver.mp3",
                            cover: "/images/contributed/violet/emerald_HirokoSumpter.jpg",
                            covercredit: "Hiroko Sumpter"
                        },
                        2: {
                            title: "Interview Clip",
                            artist: "Jill Raymond (Ray)",
                            tag: "Emerald Watch",
                            path: "/audio/contributed/violet/Interview_Ray.mp3",
                            cover: "/images/contributed/violet/emerald_SusanKleckner.jpg",
                            covercredit: "Susan Kleckner"
                        },
                        3: {
                            title: "Freya Invocation",
                            artist: "Tanya Myers",
                            tag: "Behind the Scenes",
                            path: "/audio/contributed/violet/FreyaInvocation.mp3",
                            cover: "/images/contributed/violet/emerald_GiniMags_1.png",
                            covercredit: "Gini Mags"
                        },
                        4: {
                            title: "Freya",
                            artist: "Mary Woodvine",
                            tag: "Behind the Scenes",
                            path: "/audio/contributed/violet/FreyaMembersOfCompany.mp3",
                            cover: "/images/contributed/violet/emerald_GiniMags_2.png",
                            covercredit: "Gini Mags"
                        },
                        5: {
                            title: "Greenham Hamper",
                            artist: "Lladel Bryant, Tanya Myers, Gilly Tompkins",
                            path: "/audio/contributed/violet/Hamper.mp3",
                            tag: "Behind the Scenes",
                            cover: "/images/contributed/violet/emerald_CarolynFrancisAugust1985_6.png",
                            covercredit: "Carolyn Francis"
                        },
                        6: {
                            title: "River of Birds",
                            artist: "Kathy Trevelyan",
                            path: "/audio/contributed/violet/RiverOfBirds.mp3",
                            tag: "Behind the Scenes",
                            cover: "/images/contributed/violet/emerald_VivsShopTelephoneLinkPoint1985.png",
                            covercredit: "Viv's Shop Telephone Link Point 1985"
                        }
                    }
                },
                {
                    name: "Indigo",
                    description: "Indigo was a very enclosed gate, right next to the fence. We’re still discovering new bits of history about Greenham, including more information on Indigo gate. If you have any stories about Indigo, please contact us! Please explore this gate and listen to some of the audio clips to hear memories from the Greenham Women who were there.",
                    audio: {
                        0: {
                            title: "Tomorrow",
                            artist: "Written by Peggy Seeger, performed by Alice Robinson",
                            tag: "Artists Today Respond to Greenham",
                            path: "/audio/contributed/blue/Tomorrow.mp3",
                            cover: "/images/contributed/indigo/emerald_JudeMunden.JPG",
                            covercredit: "Jude Munden"
                        },
                        1: {
                            title: "No More Genocide",
                            artist: "Written and performed by Holly Near",
                            tag: "We Have A Dream LP",
                            path: "/audio/contributed/blue/NoMoreGenocide.mp3",
                            cover: "/images/contributed/indigo/emerald_BoltCuttersTriciaNorton.jpg",
                            covercredit: "Tricia Norton"
                        },
                        2: {
                            title: "Carry Greenham Home",
                            artist: "Written and sung by Peggy Seeger",
                            tag: "We Have A Dream LP",
                            path: "/audio/contributed/yellow/CarryGreenhamHome.mp3",
                            cover: "/images/contributed/indigo/indigo_TwoPoems.png",
                            covercredit: "Two Poems"
                        },
                        3: {
                            title: "The Silos Song",
                            artist: "Rebecca Johnson",
                            tag: "We Have A Dream LP",
                            path: "/audio/contributed/yellow/TheSilosSong.mp3",
                            cover: "/images/contributed/indigo/Indigo_LynnBarlow.png",
                            covercredit: "Lynn Barlow"
                        },
                        4: {
                            title: "The Base",
                            artist: "Armorel Weston",
                            tag: "Art by Greenham Women",
                            path: "/audio/contributed/indigo/TheBase_ArmorelWeston.mp3",
                            cover: "/images/contributed/indigo/Indigo_LynnBarlow2.png",
                            covercredit: "Lynn Barlow"
                        },
                        5: {
                            title: "And Women Dance",
                            artist: "Written by Zohl de Ishtar, read by Bec Applebee",
                            tag: "Art by Greenham Women",
                            path: "/audio/contributed/indigo/ZohlDeIshtarAndWomenDance_BecAppleby.mp3",
                            cover: "/images/contributed/indigo/indigo_AndWomenDanceZohldeIshtar.png",
                            covercredit: "Zohlde Ishtar"
                        },
                        6: {
                            title: "Does Your Husband Know You're Here",
                            artist: "Peggy Seeger",
                            tag: "Interview Clips",
                            path: "/audio/contributed/indigo/Interview_PeggyDoesYourHusbandKnowYoureHere.mp3",
                            cover: "/images/contributed/indigo/emerald_ClarePolly_1.jpg",
                            covercredit: "Clare & Polly"
                        },
                        7: {
                            title: "HERstory",
                            artist: "Peggy Seeger",
                            tag: "Interview Clips",
                            path: "/audio/contributed/indigo/Interview_PeggyHERstory.mp3",
                            cover: "/images/contributed/indigo/emerald_ClarePolly_2.jpg",
                            covercredit: "Clare & Polly"
                        },
                        8: {
                            title: "Keeping The Peace",
                            artist: "Peggy Seeger",
                            tag: "Interview Clips",
                            path: "/audio/contributed/indigo/Interview_PeggyKeepingThePeace.mp3",
                            cover: "/images/contributed/indigo/emerald_ClarePolly_3.jpg",
                            covercredit: "Clare & Polly"
                        },
                        9: {
                            title: "Improvised Singing",
                            artist: "Peggy Seeger",
                            tag: "Interview Clips",
                            path: "/audio/contributed/indigo/Interview_PeggyImprovisedSinging.mp3",
                            cover: "/images/contributed/indigo/emerald_ClarePolly_4.jpg",
                            covercredit: "Clare & Polly"
                        },
                        10: {
                            title: "Singing Her Nightmare",
                            artist: "Peggy Seeger",
                            tag: "Interview Clips",
                            path: "/audio/contributed/indigo/Interview_PeggySingingHerNightmare.mp3",
                            cover: "/images/contributed/indigo/emerald_ClarePolly_5.jpg",
                            covercredit: "Clare & Polly"
                        },
                        11: {
                            title: "Finding The Audience",
                            artist: "Frankie Armstrong",
                            tag: "Interview Clips",
                            path: "/audio/contributed/indigo/Interview_FrankieFindingTheAudience.mp3",
                            caption: "Leah Thalman Banner",
                            cover: "/images/contributed/indigo/emerald_ClarePolly_11.jpg",
                            covercredit: "Clare & Polly"
                        },
                        12: {
                            title: "Out Of The Darkness Inspiration",
                            artist: "Frankie Armstrong",
                            tag: "Interview Clips",
                            path: "/audio/contributed/indigo/Interview_FrankieOutOfTheDarknessInspiration.mp3",
                            cover: "/images/contributed/indigo/emerald_ClarePolly_6.jpg",
                            covercredit: "Clare & Polly"
                        },
                        13: {
                            title: "Puppet Show at Indigo",
                            artist: "Maggie O Connor",
                            tag: "Interview Clips",
                            path: "/audio/contributed/indigo/Interview_MaggiePuppetShow.mp3",
                            cover: "/images/contributed/indigo/emerald_ClarePolly_7.jpg",
                            covercredit: "Clare & Polly"
                        },
                        14: {
                            title: "Cats",
                            artist: "Maggie O Connor",
                            tag: "Interview Clips",
                            path: "/audio/contributed/indigo/Interview_MaggieCats.mp3",
                            cover: "/images/contributed/indigo/emerald_ClarePolly_8.jpg",
                            covercredit: "Clare & Polly"
                        },
                        15: {
                            title: "NVDA & XR",
                            artist: "Maggie O Connor",
                            tag: "Interview Clips",
                            path: "/audio/contributed/indigo/Interview_MaggieNVDAXR.mp3",
                            cover: "/images/contributed/indigo/emerald_ClarePolly_9.jpg",
                            covercredit: "Clare & Polly"
                        },
                        16: {
                            title: "Power of Singing & Quakers",
                            artist: "Maggie O Connor",
                            tag: "Interview Clips",
                            path: "/audio/contributed/indigo/Interview_MaggiePowerOfSingingQuakers.mp3",
                            cover: "/images/contributed/indigo/emerald_ClarePolly_10.jpg",
                            covercredit: "Clare & Polly"
                        },
                        17: {
                            title: "Out Of The Darkness Inspiration",
                            artist: "Maggie O Connor",
                            tag: "Interview Clips",
                            path: "/audio/contributed/indigo/Interview_FrankieOutOfTheDarknessInspiration.mp3",
                            cover: "/images/contributed/indigo/indigo_LeahThalmanBanner.jpg",
                            covercredit: "Leah Thalman"
                        },
                        18: {
                            title: "Adieu les Filles",
                            artist: "Carolyn Francis",
                            tag: "Greenham Women's Art Today",
                            path: "/audio/contributed/indigo/AdieuLesFilles.mp3",
                            cover: "/images/contributed/indigo/emerald_CarolynFrancisAugust1985_5.png",
                            covercredit: "Carolyn Francis"
                        },
                        19: {
                            title: "Lockdown Waltz Woods",
                            artist: "Carolyn Francis",
                            tag: "Greenham Women's Art Today",
                            path: "/audio/contributed/indigo/LockDownWaltzWoods.mp3",
                            cover: "/images/contributed/indigo/emerald_CarolynFrancisAugust1985_3.png",
                            covercredit: "Carolyn Francis"
                        },
                        20: {
                            title: "Yordas TP Pipes Solo",
                            artist: "Carolyn Francis",
                            tag: "Greenham Women's Art Today",
                            path: "/audio/contributed/indigo/YordasTPPipesSolo.mp3",
                            cover: "/images/contributed/indigo/emerald_CarolynFrancisAugust1985_2.png",
                            covercredit: "Carolyn Francis"
                        },
                        21: {
                            title: "Best Tin Whistle With Dog",
                            artist: "Carolyn Francis",
                            tag: "Greenham Women's Art Today",
                            path: "/audio/contributed/green/BestTinWhistle.mp3",
                            cover: "/images/contributed/indigo/emerald_FiddleCarolynFrancisAugust1985_1.png",
                            covercredit: "Carolyn Francis"
                        },
                        22: {
                            title: "Wounded Hussar",
                            artist: "Carolyn Francis",
                            tag: "Greenham Women's Art Today",
                            path: "/audio/contributed/indigo/WoundedHussar.mp3",
                            cover: "/images/contributed/indigo/emerald_CarolynFrancisAugust1985_4.png",
                            covercredit: "Carolyn Francis"
                        },
                        23: {
                            title: "The Standing Tree",
                            artist: "Carolyn Francis",
                            tag: "Greenham Women's Art Today",
                            path: "/audio/contributed/indigo/TheStandingTree.mp3",
                            cover: "/images/contributed/indigo/emerald_WomynGathering.png",
                            covercredit: "Yohanna Gardener"
                        },
                    }
                },
                {
                    name: "Turquoise",
                    description: "Turquoise was a vegan gate. We’re still discovering new bits of history about Greenham, including more information on Turqoise gate. If you have any stories about Turqoise, please contact us! Please explore this gate and listen to some of the audio clips to hear memories from the Greenham Women who were there.",
                    audio: {
                        0: {
                            title: "Interview Clip",
                            artist: "Jade Britton",
                            tag: "Turquoise Gate",
                            path: "/audio/contributed/turquoise/Interview_JadeBritton.mp3",
                            cover: "/images/contributed/turquoise/emerald_PaddingtonGreenham Women.jpg",
                            covercredit: "Paddington Greenham Women"
                        },
                        1: {
                            title: "Interview Clip",
                            artist: "Penny Gulliver",
                            tag: "Turquoise Gate",
                            path: "/audio/contributed/turquoise/Interview_PennyGulliver.mp3",
                            cover: "/images/contributed/turquoise/emerald_GladysVan.jpg",
                            covercredit: "Dawn"
                        },
                        2: {
                            title: "Interview Clip",
                            artist: "Josetta Malcolm",
                            tag: "Woad Gate",
                            path: "/audio/contributed/turquoise/Interview_JosettaMalcolm.mp3",
                            cover: "/images/contributed/turquoise/emerald_ArrestArticleCarolinePoland.jpg",
                            covercredit: "Caroline Poland"
                        },
                        3: {
                            title: "Interview Clip",
                            artist: "Judith Baron",
                            tag: "Woad Gate",
                            path: "/audio/contributed/turquoise/Interview_JudithBaron.mp3",
                            cover: "/images/contributed/turquoise/blue_LeaderlessAction_SusanKleckner.jpg",
                            covercredit: "Susan Kleckner"
                        },
                        4: {
                            title: "Interview Clip",
                            artist: "Jill Raymond (Ray)",
                            tag: "Blue Gate Diaries",
                            path: "/audio/contributed/turquoise/Interview_RayWoad.mp3",
                            cover: "/images/contributed/turquoise/emerald_BridgetSue.png",
                            covercredit: "Bridget & Sue"
                        }

                    }
                },
                {
                    name: "Red",
                    description: "Red gate was a laid back, mellow gate, which was where women with children went sometimes, if they were living at camp. It was also nearest to the control tower. We’re still discovering new bits of history about Greenham, including more information on Red gate. If you have any stories about Red, please contact us! Please explore this gate and listen to some of the audio clips to hear memories from the Greenham Women who were there.",
                    audio: {
                        0: {
                            title: "Take the Toys from the Boys",
                            artist: "T.J Holmes and Becky Barry (Poison Girls)",
                            tag: "Artists Today Respond To Greenham",
                            path: "/audio/contributed/red/TakeTheToysFromTheBoys.mp3",
                            cover: "/images/contributed/red/red_KH_NVDA.jpg",
                            covercredit: "Kayleigh Hilsdon"
                        },
                        1: {
                            title: "Which Side Are You On?",
                            artist: "Jenny and Flo Crowe",
                            tag: "Artists Today Respond To Greenham",
                            path: "/audio/contributed/red/WhichSideAreYouOn.mp3",
                            cover: "/images/contributed/red/red_KH_TheMedia.jpg",
                            covercredit: "Kayleigh Hilsdon"
                        },
                        2: {
                            title: "Witches",
                            artist: "Jenny and Flo Crowe",
                            tag: "Artists Today Respond To Greenham",
                            path: "/audio/contributed/red/Witches.mp3",
                            cover: "/images/contributed/red/red_KH_Sex.jpg",
                            covercredit: "Kayleigh Hilsdon"
                        },
                        3: {
                            title: "The Ballad of Freda Geese",
                            artist: "Christina Li",
                            tag: "Artists Today Respond To Greenham",
                            path: "/audio/contributed/red/TheBalladOfFredaGeese.mp3",
                            cover: "/images/contributed/red/P1140616.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                        4: {
                            title: "There Shall be Womanly Times",
                            artist: "Frankie Armstrong, covered by Chloë Clarke",
                            tag: "Artists Today Respond to Greenham",
                            path: "/audio/contributed/red/ThereShall_ChloeClarke.mp3",
                            cover: "/images/contributed/red/red_KH_Motherhood.jpg",
                            covercredit: "Kayleigh Hilsdon"
                        },
                        5: {
                            title: "Custody of Children",
                            artist: "Tamsin Clayton",
                            tag: "Interview Clips",
                            path: "/audio/contributed/red/Interview_TamsinEvictions.mp3",
                            cover: "/images/contributed/red/P1150001.jpg",
                            covercredit: "Kayleigh Hilsdon"
                        },
                        6: {
                            title: "Red Gate",
                            artist: "Tamsin Clayton",
                            tag: "Interview Clips",
                            path: "/audio/contributed/red/Interview_TamsinRedGate.mp3",
                            cover: "/images/contributed/red/red_KH_TheGates.jpg",
                            covercredit: "Kayleigh Hilsdon"
                        },
                        7: {
                            title: "Re-establishing Red Gate",
                            artist: "Tamsin Clayton",
                            tag: "Interview Clips",
                            path: "/audio/contributed/red/Interview_TamsinRe-establishingRedGate.mp3",
                            cover: "/images/contributed/red/P1140655.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                        8: {
                            title: "Setting Up Red Gate",
                            artist: "Tamsin Clayton",
                            tag: "Interview Clips",
                            path: "/audio/contributed/red/Interview_TamsinSettingUpRedGate.mp3",
                            cover: "/images/contributed/red/red_KH_Legacy.jpg",
                            covercredit: "Kayleigh Hilsdon"
                        },
                        9: {
                            title: "Red Gate Diary",
                            artist: "Tamsin Clayton",
                            tag: "Interview Clips",
                            path: "/audio/contributed/red/Interview_TamsinRedGateDiary.mp3",
                            cover: "/images/contributed/red/P1150003.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                        10: {
                            title: "Held At Gunpoint",
                            artist: "Tamsin Clayton",
                            tag: "Interview Clips",
                            path: "/audio/contributed/red/Interview_TamsinHeldAtGunpoint.mp3",
                            cover: "/images/contributed/red/red_KH_LawAndDisorder.jpg",
                            covercredit: "Kayleigh Hilsdon"
                        },
                        11: {
                            title: "Local Residents",
                            artist: "Tamsin Clayton",
                            tag: "Interview Clips",
                            path: "/audio/contributed/red/Interview_TamsinLocalResidents.mp3",
                            cover: "/images/contributed/red/P1140877.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                        12: {
                            title: "Christmas 1984",
                            artist: "Fenja Hill",
                            tag: "Interview Clips",
                            path: "/audio/contributed/red/Interview_FenjaChristmas1984.mp3",
                            cover: "/images/contributed/red/red_KH_Art1.jpg",
                            covercredit: "Kayleigh Hilsdon"
                        },
                        13: {
                            title: "Local Residents",
                            artist: "Fenja Hill",
                            tag: "Interview Clips",
                            path: "/audio/contributed/red/Interview_FenjaLocalResidents.mp3",
                            cover: "/images/contributed/red/P1140692.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                        14: {
                            title: "The Legacy of Greenham",
                            artist: "Fenja Hill",
                            tag: "Interview Clips",
                            path: "/audio/contributed/red/Interview_FenjaTheLegacyOfGreenham.mp3",
                            cover: "/images/contributed/red/red_KH_Art2.jpg",
                            covercredit: "Kayleigh Hilsdon"
                        },
                        15: {
                            title: "Gates Coming Together",
                            artist: "Fenja Hill",
                            tag: "Interview Clips",
                            path: "/audio/contributed/red/Interview_FenjaGatesComingTogether.mp3",
                            cover: "/images/contributed/red/P1140641.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                        16: {
                            title: "Holloway",
                            artist: "Fenja Hill",
                            tag: "Interview Clips",
                            path: "/audio/contributed/red/Interview_FenjaHolloway.mp3",
                            cover: "/images/contributed/red/red_KH_WomenOnlySpace.jpg",
                            covercredit: "Kayleigh Hilsdon"
                        },
                        17: {
                            title: "Police Descrimination",
                            artist: "Fenja Hill",
                            tag: "Interview Clips",
                            path: "/audio/contributed/red/Interview_FenjaPoliceDiscrimination.mp3",
                            cover: "/images/contributed/red/P1140592.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                        18: {
                            title: "Evictions",
                            artist: "Fenja Hill",
                            tag: "Interview Clips",
                            path: "/audio/contributed/red/Interview_FenjaEvictions.mp3",
                            cover: "/images/contributed/red/red_KH_Violence.jpg",
                            covercredit: "Kayleigh Hilsdon"
                        }

                    }
                },
                {
                    name: "Orange",
                    description: "Orange gate was the furthest away from anywhere and had lots of space, including the nearby rabbit meadow. It also had a creche for the big demonstrations. We’re still discovering new bits of history about Greenham, including more information on Orange gate. If you have any stories about Orange, please contact us! Please explore this gate and listen to some of the audio clips to hear memories from the Greenham Women who were there.",
                    audio: {
                        0: {
                            title: "Lullaby for Lilly (The Fence)",
                            artist: "Tanya Myers",
                            tag: "Interview Clips",
                            path: "/audio/contributed/orange/LullabyforLilyTheFenceTanya1983.mp3",
                            cover: "/images/contributed/orange/SandieHicks03.jpg",
                            covercredit: "Sandie Hicks"
                        },
                        1: {
                            title: "Singing",
                            artist: "Jane Griffiths and Judy Harris",
                            tag: "Interview Clips",
                            path: "/audio/contributed/orange/JaneJudy_Singing.mp3",
                            cover: "/images/contributed/orange/SandieHicks09.jpg",
                            covercredit: "Sandie Hicks"
                        },
                        2: {
                            title: "Police Infiltration",
                            artist: "Jane Griffiths and Judy Harris",
                            tag: "Interview Clips",
                            path: "/audio/contributed/orange/JaneJudy_PoliceInfiltration.mp3",
                            cover: "/images/contributed/orange/SandieHicks06.jpg",
                            covercredit: "Sandie Hicks"
                        },
                        3: {
                            title: "Creative Green and Male Protests",
                            artist: "Jane Griffiths and Judy Harris",
                            tag: "Interview Clips",
                            path: "/audio/contributed/orange/JaneJudy_CreativeGreenAndMaleProtests.mp3",
                            cover: "/images/contributed/orange/orange_wpc.png",
                            covercredit: "Sandie Hicks"
                        },
                        4: {
                            title: "Crutches",
                            artist: "Jane Griffiths and Judy Harris",
                            tag: "Interview Clips",
                            path: "/audio/contributed/orange/JaneJudy_Crutches.mp3",
                            cover: "/images/contributed/orange/SandieHicks04.jpg",
                            covercredit: "Sandie Hicks"
                        },
                        5: {
                            title: "Setting Up Orange Gate",
                            artist: "Jane Griffiths and Judy Harris",
                            tag: "Interview Clips",
                            path: "/audio/contributed/orange/JaneJudy_SettingUpOrangeGate.mp3",
                            cover: "/images/contributed/orange/SandieHicks05.jpg",
                            covercredit: "Sandie Hicks"
                        },
                        6: {
                            title: "SWP Nice Granddad",
                            artist: "Hoonie Feltham",
                            tag: "More Voices",
                            path: "/audio/contributed/orange/Interview_HoonieSWPVNiceGranddad.mp3",
                            cover: "/images/contributed/orange/SandieHicks07.JPG",
                            covercredit: "Sandie Hicks"
                        },
                        7: {
                            title: "Embrace The Base",
                            artist: "Hoonie Feltham",
                            tag: "More Voices",
                            path: "/audio/contributed/orange/Interview_HoonieEmbraceTheBase.mp3",
                            cover: "/images/contributed/orange/SandieHicks08.JPG",
                            covercredit: "Sandie Hicks"
                        },
                        8: {
                            title: "Benders",
                            artist: "Hoonie Feltham",
                            tag: "More Voices",
                            path: "/audio/contributed/orange/Interview_HoonieBenders.mp3",
                            cover: "/images/contributed/orange/SandieHicks01.jpg",
                            covercredit: "Sandie Hicks"
                        },
                        9: {
                            title: "Geese",
                            artist: "Becky Griffiths",
                            tag: "More Voices",
                            path: "/audio/contributed/orange/Interview_HoonieGeeseBeckyGriffithsSong.mp3",
                            cover: "/images/contributed/orange/P1140579.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                        10: {
                            title: "Dumping Of Nuclear Waste",
                            artist: "Betty Levene",
                            tag: "More Voices",
                            path: "/audio/contributed/orange/Interview_BettyDumpingOfNuclearWaste.mp3",
                            cover: "/images/contributed/orange/P1140568.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                        11: {
                            title: "Empowering Women",
                            artist: "Betty Levene",
                            tag: "More Voices",
                            path: "/audio/contributed/orange/Interview_BettyEmpoweringWomen.mp3",
                            cover: "/images/contributed/orange/SandieHicks02.JPG",
                            covercredit: "Sandie Hicks"
                        },
                        12: {
                            title: "NVDA Affinity Groups",
                            artist: "Betty Levene",
                            tag: "More Voices",
                            path: "/audio/contributed/orange/Interview_BettyNVDAAffinityGroups.mp3",
                            cover: "/images/contributed/orange/P1140576.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                        13: {
                            title: "Men Living At Camp",
                            artist: "Betty Levene",
                            tag: "More Voices",
                            path: "/audio/contributed/orange/Interview_BettyMenLivingAtCamp.mp3",
                            cover: "/images/contributed/orange/P1140560.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                        14: {
                            title: "Relationships With The Police",
                            artist: "Betty Levene",
                            tag: "More Voices",
                            path: "/audio/contributed/orange/Interview_BettyRelationshipsWithPolice.mp3",
                            cover: "/images/contributed/orange/P1140541.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                        15: {
                            title: "Quakers",
                            artist: "Lorna Richardson",
                            tag: "More Voices",
                            path: "/audio/contributed/orange/Interview_LornaQuakers.mp3",
                            cover: "/images/contributed/orange/yellow_10Years.jpg",
                            covercredit: "10 Years"
                        },
                        16: {
                            title: "Recording Greenham",
                            artist: "Lorna Richardson",
                            tag: "More Voices",
                            path: "/audio/contributed/orange/Interview_LornaRecordingGreenham.mp3",
                            cover: "/images/contributed/orange/yellow_10MMWomen_SusanKleckner.jpg",
                            covercredit: "Susan Kleckner"
                        },
                        17: {
                            title: "Visibility Action",
                            artist: "Lorna Richardson",
                            tag: "More Voices",
                            path: "/audio/contributed/orange/Interview_LornaVisibilityAction.mp3",
                            cover: "/images/contributed/orange/P1140508.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                        18: {
                            title: "Star Wars At Greenham",
                            artist: "Lorna Richardson",
                            tag: "More Voices",
                            path: "/audio/contributed/orange/Interview_LornaStarWarsAtGreenham.mp3",
                            cover: "/images/contributed/orange/P1140560.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                        19: {
                            title: "What Is A Greenham Woman?",
                            artist: "Lorna Richardson",
                            tag: "More Voices",
                            path: "/audio/contributed/orange/Interview_LornaWhatIsAGreenhamWoman.mp3",
                            cover: "/images/contributed/orange/P1140478.jpg",
                            covercredit: "Bridget Boudewijn"
                        },
                    }
                },


            ]
        }
    }
}
